import { gql } from "@apollo/client";

export const GET_FEATURE_CATALOGS = gql`
  query GetFeatureCatalogs($feature_type_id: Int!) {
    get_feature_catalogs(feature_type_id: $feature_type_id) {
      id
      subscriptionId
      name
      description
      updatedAt
      updatedBy
      itemCount
      addedBy
      addedOn
    }
  }
`;

export const GET_FEATURE_CATALOG_ITEMS = gql`
  query GetFeatureCatalogItems($feature_type_id: Int!, $catalog_id: uuid!) {
    get_feature_catalog_items(
      feature_type_id: $feature_type_id
      catalog_id: $catalog_id
    ) {
      items {
        id
        sort_no
        title
        description
        deleted
        uniformat {
          id
          number
          title
        }
        masterformat {
          id
          number
          title
        }
        classifications {
          id
          number
          parent_id
          path
          system
          title
        }
      }
    }
  }
`;

export const BOOTSTRAP_FEATURE_CATALOG = gql`
  mutation BootstrapFeatureCatalog(
    $feature_type_id: Int!
    $catalogIds: [uuid!]!
  ) {
    bootstrap_feature_catalog(
      feature_type_id: $feature_type_id
      catalogIds: $catalogIds
    ) {
      results {
        importLogId
        catalogId
        catalogName
        created
        skipped
        status
        error
      }
    }
  }
`;

export const DELETE_FEATURE_CATALOG = gql`
  mutation DeleteFeatureCatalog($feature_type_id: Int!, $catalog_id: uuid!) {
    delete_feature_catalog(
      feature_type_id: $feature_type_id
      catalog_id: $catalog_id
    ) {
      catalog_id
    }
  }
`;

export const DELETE_FEATURE_CATALOG_ITEM = gql`
  mutation DeleteFeatureCatalogItem(
    $feature_type_id: Int!
    $catalog_id: uuid!
    $item_id: uuid!
  ) {
    delete_feature_catalog_item(
      feature_type_id: $feature_type_id
      catalog_id: $catalog_id
      item_id: $item_id
    ) {
      item_id
    }
  }
`;
